import { getSmoothStepPath, Position } from '@xyflow/system';

const EDGE_RADIUS = 8;
const EDGE_OFFSET = 8;
export const WIRE_SNAP_Y = 12;

export function edgePath(source, target) {
  return pathBetween(anchor(source, 'bottom'), anchor(target, 'top'));
}

export function mcpPath(source, target) {
  const rightward = center(target) >= center(source);
  const start = sideAnchor(source, rightward ? 'right' : 'left');
  const end = mcpAnchor(target, rightward ? 'left' : 'right');

  if (Math.abs(start.y - end.y) <= WIRE_SNAP_Y) return `M ${start.x},${start.y} L ${end.x},${end.y}`;

  return smoothPath(start, end, {
    source: rightward ? Position.Right : Position.Left,
    target: rightward ? Position.Left : Position.Right,
  });
}

export function anchor(card, side) {
  const x = left(card) + card.offsetWidth / 2;
  const y = top(card);

  return { x, y: side === 'bottom' ? y + card.offsetHeight : y };
}

export function heading(from, to) {
  return Math.atan2(to.y - from.y, to.x - from.x);
}

function sideAnchor(card, side) {
  const x = left(card);

  return { x: side === 'right' ? x + card.offsetWidth : x, y: top(card) + card.offsetHeight / 2 };
}

function mcpAnchor(card, side) {
  const badge = card.querySelector('[data-role="badge"]') ?? card;
  const x = left(card) + badge.offsetLeft;
  const y = top(card) + badge.offsetTop;

  return { x: side === 'left' ? x : x + badge.offsetWidth, y: y + badge.offsetHeight / 2 };
}

export function pathBetween(start, end) {
  return smoothPath(start, end, { source: Position.Bottom, target: Position.Top });
}

function smoothPath(start, end, sides) {
  const [path] = getSmoothStepPath({
    sourceX: start.x,
    sourceY: start.y,
    sourcePosition: sides.source,
    targetX: end.x,
    targetY: end.y,
    targetPosition: sides.target,
    borderRadius: EDGE_RADIUS,
    offset: EDGE_OFFSET,
  });

  return path;
}

function center(card) {
  return left(card) + card.offsetWidth / 2;
}

function left(card) {
  return parseFloat(card.style.left) || 0;
}

function top(card) {
  return parseFloat(card.style.top) || 0;
}
